import React, { useState } from "react";
import { Box, Text, Tip } from "grommet";
import { DisplayInlineBlockBox, UnderlinedText } from "../../../utils/styled";
import CopyLinkWidget from "../../CopyLinkWidget";
import ImportCustomerModal from "../../ImportCustomerModal";
import { useSession } from "next-auth/react";
import { nonRedirectFetcher } from "../../../utils/errors";
import useSWR from "swr";
import Button from "../../Button";
import { DROPDOWN_MENU_DESKTOP_WIDTH } from "../../../constants/Dimensions";
import { useRouter } from "next/router";

const CustomerImportMenu = ({
    wrapperProps,
    onAddGroup
}) => {
    const {data: session} = useSession();
    const {user} = session || {};
    const router = useRouter();
    const [showImportModal, setShowImportModal] = useState(false);

    // accountData is only used for the optional onboarding-link widget. Use
    // nonRedirectFetcher so a 403 (users without settings access) hides that widget
    // instead of triggering the global 403 redirect to the dashboard.
    const { data: accountData } = useSWR("/api/settings/account", nonRedirectFetcher, {
        revalidateOnFocus: false,
    });

    return (
        <>
            {showImportModal && (
                <ImportCustomerModal
                    onClose={() => setShowImportModal(false)}
                    importMethod={"CSV"}
                    user={user}
                    onImportStarted={() => {
                        setShowImportModal(false);
                        router.reload();
                    }}
                />
            )}
            <Box
                align='start'
                width={DROPDOWN_MENU_DESKTOP_WIDTH}
                border
                pad='xsmall'
                gap="small"
                {...wrapperProps}>
                <Box fill="horizontal" pad="xxsmall">
                    {onAddGroup && (
                        <Button
                            event={{section: 'customer_import_menu', element: 'add_group'}}
                            fill
                            plain
                            pad={{horizontal: 'small', vertical: 'xsmall'}}
                            onClick={onAddGroup}
                            hoverIndicator
                            label={(
                                <Box align='start' pad="xsmall">
                                    <Text weight={400}>Create customer group</Text>
                                </Box>
                            )}
                        />
                    )}
                    <Button
                        event={{section: 'customer_import_menu', element: 'import_csv'}}
                        fill
                        plain
                        pad={{horizontal: 'small', vertical: 'xsmall'}}
                        onClick={() => setShowImportModal(true)}
                        hoverIndicator
                        label={(
                            <Box align='start' pad="xsmall">
                                <Text weight={400}>Import customers from CSV</Text>
                            </Box>
                        )}
                    />
                </Box>
                {accountData?.slug && (
                    <Box border='top' fill="horizontal" pad="small" gap='xsmall'>
                        <Box margin={{top: 'xsmall'}}>
                            <Text weight={400}>Share this link for easy onboarding:</Text>
                        </Box>
                        <CopyLinkWidget
                            component="customer_page_header"
                            link={`${typeof window !== 'undefined' ? window.location.origin : ''}/hi/${accountData?.slug}`}
                        />
                        <DisplayInlineBlockBox>
                            <Tip
                                content={(
                                    <Box width={{max: 'medium'}} pad="xsmall" gap="xsmall">
                                        <Text>
                                            Onboard your customers automatically with this link. Share the link with them, and they can add their own details right into Streamlined.
                                        </Text>
                                    </Box>
                                )}>
                                <UnderlinedText
                                    textDecoration="underline"
                                    color='text-weak'
                                    size="small">
                                        How does it work?
                                </UnderlinedText>
                            </Tip>
                        </DisplayInlineBlockBox>
                    </Box>
                )}
            </Box>
        </>
    );
};

export default CustomerImportMenu;
